export default __webpack_public_path__ + "static/media/uv4.814ba319.svg";